var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStudent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04863 0.397692C6.84739 0.311446 6.6196 0.311446 6.41836 0.397692L0.818361 2.79769C0.524214 2.92375 0.333496 3.21299 0.333496 3.53301C0.333496 3.85303 0.524214 4.14226 0.818361 4.26832L2.93379 5.17494C3.01072 5.08778 3.10715 5.01679 3.21836 4.96913L6.41836 3.5977C6.82446 3.42366 7.29477 3.61178 7.46881 4.01788C7.64286 4.42399 7.45473 4.89429 7.04863 5.06833L4.86684 6.00339L6.41836 6.66832C6.6196 6.75457 6.84739 6.75457 7.04863 6.66832L12.6486 4.26832C12.9428 4.14226 13.1335 3.85303 13.1335 3.53301C13.1335 3.21299 12.9428 2.92375 12.6486 2.79769L7.04863 0.397692Z",
    fill: "#70758F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38153 6.25039L2.7335 6.8298V10.1111C2.45928 10.0489 2.17914 10.0024 1.89406 9.9725C1.51825 9.9331 1.22125 9.6361 1.18185 9.26029C1.14987 8.95527 1.1335 8.64585 1.1335 8.33287C1.1335 7.61565 1.21942 6.9182 1.38153 6.25039Z",
    fill: "#70758F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17346 11.991C5.63516 11.4633 5.01483 11.0197 4.3335 10.6811V7.51552L5.78809 8.13892C6.39181 8.39765 7.07518 8.39765 7.6789 8.13892L12.0855 6.25039C12.2476 6.9182 12.3335 7.61565 12.3335 8.33287C12.3335 8.64585 12.3171 8.95527 12.2851 9.26029C12.2457 9.63611 11.9487 9.9331 11.5729 9.9725C9.91466 10.1464 8.4234 10.8834 7.29353 11.991C6.98245 12.296 6.48454 12.296 6.17346 11.991Z",
    fill: "#70758F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5335 13.133C3.97532 13.133 4.3335 12.7748 4.3335 12.333V10.6811C3.83058 10.4311 3.29443 10.2384 2.7335 10.1111V12.333C2.7335 12.7748 3.09167 13.133 3.5335 13.133Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudent);
export default __webpack_public_path__ + "static/media/icon-student.79d60d93e782f50087f996d61f59589e.svg";
export { ForwardRef as ReactComponent };